export default {"src":"/_next/static/media/icon_22.f6b48421.svg","height":48,"width":48};